/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brand: NonNullable<unknown>, last4: NonNullable<unknown> }} Plan_Card_DisplayInputs */

const en_plan_card_display = /** @type {(inputs: Plan_Card_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.brand} •••• ${i?.last4}`)
};

const es_plan_card_display = /** @type {(inputs: Plan_Card_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.brand} •••• ${i?.last4}`)
};

/**
* | output |
* | --- |
* | "{brand} •••• {last4}" |
*
* @param {Plan_Card_DisplayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_card_display = /** @type {((inputs: Plan_Card_DisplayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_DisplayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_card_display(inputs)
	return en_plan_card_display(inputs)
});